import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const DividerVertical = styled.div`
    width: 1px;
    background-color: ${theme.colors.border.subtle};
`;
